import { Chip } from "@nextui-org/react";
import { FC } from "react";

interface IProps {
  label: string;
  onClick: () => void;
}

export const Variable: FC<IProps> = ({ label, onClick }) => {
  return (
    <Chip
      classNames={{
        base: "border-1 border-brand-blue-100 bg-brand-blue-50 cursor-pointer hover:bg-brand-blue-100 min-h-7",
        content:
          "text-brand-blue-900 text-sm font-medium px-0 first-letter:uppercase",
      }}
      color="primary"
      radius="sm"
      variant="flat"
      onClick={onClick}
    >
      {label}
    </Chip>
  );
};
